import React, { useState, useEffect, useRef } from "react";

import SearchBar from "../components/Search";
import Header from "../components/Header";
import AppCard from "../components/AppCard";
import StatCard from "../components/StatCard";
import trendIcon from "../assets/res/trend_icon.svg"
import modsIcon from "../assets/res/star_mod_icon.svg"
import timeIcon from "../assets/res/time_icon.svg"

const GamesPage = ({ handleItemClick, numbers }) => {
  const [filteredGames, setFilteredGames] = useState([]);
  const [query, setQuery] = useState("");
  const [hideStats, setHideStats] = useState(false);

  const inputRef = useRef(null);

  const handleFocus = (focus) => {

    setHideStats(focus)
  };


  function querySearched(q) {
    setQuery(q);
  }

  const searchItems = (array, query) => {

    console.log(query);
    if (!query) return array; // Return the original array if no search term is provided

    const lowercasedTerm = String(query).toLowerCase();

    return array.filter((item) => {
      return (
        String(item.name).toLowerCase().includes(lowercasedTerm)
      );
    });
  };

  const filteredItems = searchItems(numbers, query);

  useEffect(() => {
    // Filter the games and copy the result to filteredGames state
    const newFilteredGames = numbers.filter((game) => game.category === "1");
    setFilteredGames(newFilteredGames.slice()); // Create a copy using slice()
  }, [numbers]);

  return (
    <div className="min-h-screen lg:mx-auto lg:w-[500px] lg:border-[1px] drop-shadow  bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
      <Header
        querySearched={querySearched}
        onFocusSearched={handleFocus}
      />

      {!hideStats &&
        <div className="flex gap-[12px] px-[16px] pt-[16px]">
          <StatCard
            icon={trendIcon}
            value={"1.2M+"}
            label={"Downloads"}
          />

          <StatCard
            icon={modsIcon}
            value={"850+"}
            label={"Mods"}
          />

          <StatCard
            icon={timeIcon}
            value={"Daily"}
            label={"Updates"}
          />

        </div>}

      <div className="pt-[16px] space-y-4 mb-4 ">
        {filteredItems
          .slice(0, 20)
          .reverse()
          .map((app, index) => (
            <AppCard
              key={index}
              app={app}
              onGameClicked={() => handleItemClick(app)}
            />
          ))}
      </div>
    </div>
  );
};

export default GamesPage;
